export default {
    UnprocessableEntity : 'UnprocessableEntity',
    FORBIDDEN : 'forbidden'

}